import React from "react";
import logo from "../../assets/images/on-icon.svg";

const onLogo = props => <img className={props.className} src={logo} alt="on-off" />;

export default onLogo;
